<ng-container *ngIf="(periodCloseComponent.loading$ | async) === true">
  <div class="border-8 h-32 m-auto mt-40 spinner w-32"></div>
</ng-container>

<ng-container *ngIf="(periodCloseComponent.loading$ | async) === false">
  <div class="pt-4 pb-6 px-7">
    <div class="flex flex-col items-center mb-4 px-7">
      <div class="flex self-end space-x-4 text-sm items-center">
        <button
          *ngIf="showRequestJournalEntryButton$ | async"
          class="btn--secondary pl-3"
          data-pendo-id="request-journal-entry-report"
          type="button"
          (click)="onRequestJournalEntryReport()"
        >
          <span inlineSVG="message.svg"></span>
          <span class="ml-2">Request Journal Entry Report</span>
        </button>
        <button
          class="btn--secondary pl-3"
          type="button"
          [disabled]="(isDownloadVendorEstimateButtonDisabled$ | async) !== false"
          (click)="onDownloadVendorEstimates()"
        >
          <span inlineSVG="download.svg"></span>
          <span class="ml-2">Download Vendor Estimate(s)</span>
        </button>

        <button
          type="button"
          class="btn--secondary pl-3"
          (click)="onAddVendorEstimateUploadClick()"
        >
          <span inlineSVG="circle-plus.svg"></span>
          <span class="ml-2">Add Vendor Estimate(s)</span>
        </button>

        <aux-export-excel-button
          [gridAPI]="gridAPI"
          [variant]="exportButtonVariant"
          [excelOptions]="excelOptions"
          [getDynamicExcelParamsCallback]="getDynamicExcelParams"
        >
        </aux-export-excel-button>

        <aux-menu #forecast_down_up_load_menu>
          <button
            type="button"
            role="menuitem"
            class="hover:bg-gray-100 hover:text-gray-900 text-gray-700 px-4 py-2 text-sm w-full flex items-center focus:outline-none"
            (click)="onVendorEstimateUploadClick(); forecast_down_up_load_menu.close()"
          >
            <span inlineSVG="file-upload.svg"></span>
            <span class="ml-2">Upload Vendor Estimate</span>
          </button>
        </aux-menu>
      </div>
    </div>

    <div *ngIf="periodCloseComponent.gridDataMergedDiscount$ | async as gridData">
      <div class="w-full" *ngIf="showGrid$ | async">
        <ag-grid-angular
          class="ag-theme-aux tabular-nums quarter-close-table w-full"
          domLayout="autoHeight"
          [rowData]="gridData"
          [gridOptions]="$any(gridOptions$ | async)"
          [components]="components"
          (gridReady)="onGridReady($event)"
          (firstDataRendered)="onFirstDataRendered($event)"
          (cellValueChanged)="onCellValueChanged($event)"
          (modelUpdated)="refreshRows()"
          (viewportChanged)="onWindowScroll()"
          [postProcessPopup]="postProcessPopup"
          (filterChanged)="onFilterChanged($event)"
        ></ag-grid-angular>
      </div>
    </div>
  </div>
</ng-container>
